import React from "react";
import {Table} from "reactstrap";

interface FpsMetricsVerticalProps {
  fpsMetrics?: {
    profile: string;
    resolution: string;
    pc1: number;
    avg: number;
    max: number;
    stdev: number;
  };
}

const FpsMetricsVertical: React.FC<FpsMetricsVerticalProps> = ({fpsMetrics}) => {
  if (!fpsMetrics) {
    return null;
  }

  // FPS performance thresholds
  const bestThreshold = 60;
  const betterThreshold = 45;

  const getFpsClass = (value: number): string => {
    if (value >= bestThreshold) {
      return "good";
    }
    if (value >= betterThreshold) {
      return "medium";
    }
    return "bad";
  };

  return (
    <div className="fps-metrics-vertical">
      <h6 className="text-muted mb-2">
        <i className="fa fa-tv mr-2"></i>
        Graphics
      </h6>
      <Table size="sm" className="side-metrics">
        <tbody>
          <tr>
            <td>Profile</td>
            <td style={{textAlign: "right"}}>
              <div className="numbers neutral small">{fpsMetrics.profile}</div>
            </td>
          </tr>
          <tr>
            <td>Resolution</td>
            <td style={{textAlign: "right"}}>
              <div className="numbers neutral small">{fpsMetrics.resolution}</div>
            </td>
          </tr>
          <tr>
            <td>
              P<sub>1</sub>
            </td>
            <td style={{textAlign: "right"}}>
              <div className={`numbers ${getFpsClass(fpsMetrics.pc1)} small`}>{fpsMetrics.pc1}</div>
            </td>
          </tr>
          <tr>
            <td>Avg</td>
            <td style={{textAlign: "right"}}>
              <div className={`numbers ${getFpsClass(fpsMetrics.avg)} small`}>{fpsMetrics.avg}</div>
            </td>
          </tr>
          <tr>
            <td>Max</td>
            <td style={{textAlign: "right"}}>
              <div className={`numbers ${getFpsClass(fpsMetrics.max)} small`}>{fpsMetrics.max}</div>
            </td>
          </tr>
          <tr>
            <td>Std Dev</td>
            <td style={{textAlign: "right"}}>
              <div className="numbers neutral small">{fpsMetrics.stdev}</div>
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
};

export default FpsMetricsVertical;
